import React from 'react';
import { Stack } from '@mui/material';
import { PlayCircleOutline as PlayIcon } from '@mui/icons-material';
import SectionContainer from '../shared/SectionContainer';
import LandingCtaButton from '../shared/LandingCtaButton';
import { PLATFORM_DEMO_SECTION, PLATFORM_DEMO_TEASER } from '../../../config/demoVideos';

const ProductToursTeaserSection = () => (
  <SectionContainer
    id={PLATFORM_DEMO_SECTION.id}
    title={
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
        <PlayIcon sx={{ color: 'primary.main', fontSize: 32 }} aria-hidden="true" />
        <span>{PLATFORM_DEMO_TEASER.title}</span>
      </Stack>
    }
    subtitle={PLATFORM_DEMO_TEASER.subtitle}
    titleId="platform-demo-videos-heading"
    bgcolor="background.paper"
    py={{ xs: 4, md: 5 }}
  >
    <Stack alignItems="center" data-testid="product-tours-teaser">
      <LandingCtaButton
        to={PLATFORM_DEMO_TEASER.cta.to}
        label={PLATFORM_DEMO_TEASER.cta.label}
        variant={PLATFORM_DEMO_TEASER.cta.variant}
      />
    </Stack>
  </SectionContainer>
);

export default ProductToursTeaserSection;
